export const NavLinkItemTypeValues = [
  "home",
  "clubs",
  "venues",
  "leagues",
  "tournaments",
  "users",
  "coaches",
  "organizations",
  "licenses",
  "issuedLicenses",
  "certificates",
  "issuedCertificates",
  "applicationForms",
  "issuedApplicationForms",
  "platforms",
  "sports",
  "disciplines",
  "thirdPartyLicenses",
  "platformManagers",
  "platformSettings",
  "organizationSettings",
  "userSettings",
  "specificVenue",
  "news",
  "gallery",
  "documents",
  "pages",
  "banners",
  "partners",
  "transactions",
  "stripeConnect",
  "platformStripeAccounts",
  "integrations",
  "helpCenter",
  "tutorials",
  "contactSupport",
  "news",
  "teams",
  "managementTeam",
  "auditLogs",
  "documentation",
] as const;

export type NavLinkItemType = (typeof NavLinkItemTypeValues)[number];

export type NavLinkItem = (
  | {
      type: "home";
    }
  | {
      type: "leagues";
    }
  | {
      type: "tournaments";
    }
  | {
      type: "users";
    }
  | {
      type: "coaches";
    }
  | {
      type: "organizations";
    }
  | {
      type: "licenses";
    }
  | {
      type: "issuedLicenses";
    }
  | { type: "certificates" }
  | { type: "issuedCertificates" }
  | { type: "applicationForms" }
  | { type: "issuedApplicationForms" }
  | { type: "partners" }
  | { type: "platforms" }
  | { type: "sports" }
  | { type: "disciplines" }
  | { type: "thirdPartyLicenses" }
  | { type: "platformManagers" }
  | {
      type: "platformSettings";
    }
  | {
      type: "organizationSettings";
    }
  | {
      type: "userSettings";
    }
  | {
      type: "specificVenue";
      venueId: string;
    }
  | { type: "venues" }
  | { type: "clubs" }
  | { type: "gallery" }
  | { type: "documents" }
  | { type: "pages" }
  | { type: "banners" }
  | { type: "transactions" }
  | { type: "stripeConnect" }
  | { type: "platformStripeAccounts" }
  | { type: "integrations" }
  | { type: "helpCenter" }
  | { type: "tutorials" }
  | { type: "contactSupport" }
  | { type: "news" }
  | { type: "teams" }
  | { type: "managementTeam" }
  | { type: "auditLogs" }
  | { type: "documentation" }
) & { isHidden?: boolean };

export const NavLinkGroupTypeValues = [
  "governing",
  "data",
  "settings",
  "appearance",
  "finance",
  "superData",
  "other",
] as const;

export type NavLinksGroupType = (typeof NavLinkGroupTypeValues)[number];

export type NavLinksGroup = {
  type: NavLinksGroupType;
  items: NavLinkItem[];
};
